import http from '../http/http';
import URL from '../constant/URL';

const { STAGE, HISTORY, DETAIL, AIBAROSAM_DETAIL } = URL.API.OCR;

// 추천학습 목록
export const recommendListAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${STAGE}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code };
    },
    error: (error) => {
      throw error
    }
  });

  return result;
}

// 추천학습 상세 데이터 조회
export const recommendDetAPI = async (data) => {
  let result = null;
  
  await http.request({
    url: `${DETAIL}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code };
    },
    error: (error) => {
      result = { code: error.code, resp: error.msg }
    }
  });

  return result;
}

// 추천학습 상세 데이터 조회
export const recommendAiBarosamDetAPI = async (data) => {
  let result = null;
  
  await http.request({
    url: `${AIBAROSAM_DETAIL}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code };
    },
    error: (error) => {
      result = { code: error.code, resp: error.msg }
    }
  });

  return result;
}

// History 목록
export const historyListAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${HISTORY}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code };
    },
    error: (error) => {
      throw error
    }
  });

  return result;
};

// History 삭제
export const historyDelAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${HISTORY}`,
    method: http.METHOD.DELETE,
    data,
    success: (resp, code) => {
      result = { resp, code };
    },
    error: (error) => {
      throw error
    }
  });

  return result;
};
